/**
 * Function generating a collection of 24 hours for select on hourly absence request.
 * @returns {array} - an array of objects ready to be populated as select options.
 */
export default () => {
  const hoursArray = [];
  // eslint-disable-next-line no-plusplus
  for (let item = 0; item < 24; item++) {
    const hour = item.toString().padStart(2, "0");
    hoursArray.push({ label: `${hour}:00`, value: item });
  }
  return hoursArray;
};
